const defaultConfig = {
  throwOnInvalid: true,
  separator: '.',
}

/**
 * Event validation plugin
 * @param {object}  pluginConfig - Plugin settings
 * @param {string}  pluginConfig.context - Name of app event is in. Example 'api', 'app', 'site', 'cli'
 * @param {boolean} pluginConfig.objects - Objects events can effect
 * @param {boolean} [pluginConfig.throwOnInvalid] - Objects events can effect
 * @return {object} Analytics plugin
 * @example
 *
 * eventValidation({
 *   context: 'app',
 *   objects: ['sites', 'user', 'subscription']
 * })
 */
export default function eventValidationPlugin(pluginConfig = {}) {
  return {
    name: 'event-validation',
    config: {
      ...defaultConfig,
      ...pluginConfig,
    },
    trackStart: ({ payload, config, abort }) => {
      const isValid = isValidEventName(payload.event, config)
      if (!isValid) {
        const msg = `invalid analytics event name ${payload.event}`
        if (config.throwOnInvalid) {
          throw new Error(msg)
        }
        return abort(msg)
      }
    },
  }
}

function isValidEventName(event, config) {
  const { objects, context, separator } = config
  const validProject = Array.isArray(context) ? context : [context]
  const validObjects = Array.isArray(objects) ? objects : [objects]
  const invalid = formatError(event, separator, validProject[0], validObjects[0])
  const underscoreCount = contains(event, '_')
  if (underscoreCount !== 1) {
    // return invalid(`Event must have single underscore. "${event}" contains ${underscoreCount}`)
  }
  const colonCount = contains(event, separator)
  if (colonCount !== 1) {
    return invalid(`Event must have single "${separator}", "${event}" contains ${colonCount}`)
  }

  const matches = event.match(/([a-zA-Z0-9]+)\.([a-zA-Z0-9]+)_([a-zA-Z0-9]+$)/)
  if (!matches) {
    return invalid('Event malformed')
  }
  const [, contextValue, object, action] = matches
  // if missing any parts of event, exit;
  if (!contextValue || !object || !action) {
    return invalid('Missing context, object, or action')
  }
  /* Validate project name */
  if (validProject.indexOf(contextValue) === -1) {
    return invalid(`Invalid context "${contextValue}". Must be 1 of ${JSON.stringify(validProject)}`)
  }
  /* Validate object */
  if (validObjects.indexOf(object) === -1) {
    return invalid(`Invalid object "${object}". Must be 1 of ${JSON.stringify(validObjects)}`)
  }
  return true
}

function contains(str, char) {
  const character = char === '.' ? '\\.' : char
  const regex = new RegExp(character, 'g')
  return (str.match(regex) || []).length
}

function formatError(event, separator, validProject = 'app', validObject = 'thing') {
  return (msg) => {
    console.log(`> Invalid event "${event}"`)
    if (msg) console.log(msg)
    console.log(`> Formatting information:`)
    console.log(`Event must match pattern "context${separator}objectName_actionName"`)
    console.log(`Event must be camelCased "camelCase${separator}camelCase_camelCase"`)
    console.log(`Example: ${validProject}${separator}${validObject}_created`)
    return false
  }
}
